import { computed, defineComponent, ref } from 'vue';
import { useStore } from 'vuex';
import { useDateFormat } from '@/composables/dateFormat';
import { ProjectGetter } from '@/store/project/project.module';
import { Project } from '@/store/project/project.model';
import { CancelGetter } from '@/store/cancel/cancel.module';
import { Cancel } from '@/store/cancel/cancel.model';
import ProjectCommentOffcanvasComponent from '../projectCommentOffcanvas/ProjectCommentOffcanvas.vue';
import ProjectCancelAttachmentOffcanvasComponent from '@/components/project/cancel/projectCancelAttachmentOffcanvas/ProjectCancelAttachmentOffcanvas.vue';

export default defineComponent({
  name: 'ProjectResultComponent',
  components: {
    ProjectCommentOffcanvasComponent,
    ProjectCancelAttachmentOffcanvasComponent,
  },
  props: {
    projectId: {
      type: Number,
    },
    showEnjoins: {
      type: Boolean,
      default: true,
    }
  },
  setup: (props) => {
    const dateFormat = useDateFormat();
    const store = useStore();
    const project = computed<Project | undefined>(() => store.getters[ProjectGetter.BY_ID](props.projectId));
    const cancel = computed<Cancel | undefined>(() => store.getters[CancelGetter.GET]);
    const projectCommentOffcanvas = ref<InstanceType<typeof ProjectCommentOffcanvasComponent>>();
    const projectCancelAttachmentOffcanvas = ref<InstanceType<typeof ProjectCancelAttachmentOffcanvasComponent>>();

    const showComment = () => {
      projectCommentOffcanvas.value?.show();
    };

    const showAttachment = () => {
      projectCancelAttachmentOffcanvas.value?.show();
    };

    const thaiDate = (date: Date) =>
      dateFormat.toThaiDate(date, 'long');

    const status = (isCanceled: boolean, name: string, color: string) => {
      if (isCanceled) {
        return '<span class="text-danger">ยกเลิก</span>';
      }

      return `<span style="color: ${color}">${name}</span>`;
    };

    return {
      project,
      cancel,
      projectCommentOffcanvas,
      projectCancelAttachmentOffcanvas,
      showComment,
      showAttachment,
      thaiDate,
      status,
    };
  }
});
